import { ClientPortalApiClient } from "./ClientPortalApiClient";
import { AuthenticationApiClient } from "./AuthenticationApiClient";

export default class ApiFactory {
  public static CreateDataClient(): ClientPortalApiClient {
    return new ClientPortalApiClient(process.env.VUE_APP_API_BASE_URL);
  }

  public static CreateAuthClient(): AuthenticationApiClient {
    return new AuthenticationApiClient(process.env.VUE_APP_API_AUTH_URL);
  }
}
